import { render, staticRenderFns } from "./package_history.vue.js?vue&type=template&id=31b6df5d!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./package_history.vue?vue&type=template&id=31b6df5d"
import script from "./package_history.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./package_history.vue?vue&type=script&lang=js"
export * from "./package_history.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./package_history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports